import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkClassificationListComponent } from './work-classification-list/work-classification-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WorkClassificationTreeComponent } from './work-classification-tree/work-classification-tree.component';
import { WorkClassificationFormComponent } from './work-classification-form/work-classification-form.component';
import { RouterModule, Routes } from '@angular/router';
import { WorkClassificationComponent } from './work-classification.component';
import { CopyClassificationsToProjectDialogComponent } from './work-classification-tree/copy-to-project-dialog/copy-to-project-dialog.component';
import { WorkClassificationSelectorComponent } from './work-classification-selector/work-classification-selector.component';
import { PermissionGuard } from 'src/app/shared/guards/permission.guard';
import { PermissionConstants as Permissions } from 'src/app/constants/permissions';

// Class B: these leaves had no guard and relied entirely on the parent 'classification'
// node. Gated with the same permissions they already inherit, so access is unchanged —
// but widening the parent for the planned move out of worktime can no longer expose them.
const classificationAccess = {
  canActivate: [PermissionGuard],
  data: {
    requiredPermission: [
      Permissions.WorkClassificationPermissions.CanViewWorkClassification,
      Permissions.WorkClassificationPermissions.CanManageWorkClassification,
    ],
  },
};

const routes:Routes = [
  {
    path: '', component: WorkClassificationComponent,
    children: [
      {path: '', redirectTo: 'tree', pathMatch: 'full'},
      {path: 'list', component: WorkClassificationListComponent, ...classificationAccess},
      {path: 'form', component: WorkClassificationFormComponent, ...classificationAccess},
      {path: 'tree', component: WorkClassificationTreeComponent, ...classificationAccess},
    ]
  },
];
@NgModule({
  declarations: [
    WorkClassificationComponent,
    WorkClassificationListComponent,
    WorkClassificationTreeComponent,
    WorkClassificationFormComponent,
    CopyClassificationsToProjectDialogComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
  ]
})
export class WorkClassificationModule { }
